module.exports = __webpack_public_path__ + "media/widget/VitalSigns-1ac71259.png";